//----- AUTOGENERATED (changes will be overwritten) -------
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dOrders$dPayments$dTypes from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const GetPaymentChannelsResponse = x => x;
const GetPaymentChannelsRequest = x => x;
const eqGetPaymentChannelsRespo = {eq: x => y => Data$dEq.eqArrayImpl(Restaumatic$dOrders$dPayments$dTypes.eqChannelInfo.eq)(x.channels)(y.channels)};
const eqGetPaymentChannelsReque = {eq: x => y => x.restaurantId === y.restaurantId};
const rpcMethodNameGetPaymentChannelsRequest = {rpcMethodName: v => "GetPaymentChannelsRequest"};
const newtypeGetPaymentChannelsResponse = {Coercible0: () => {}};
const newtypeGetPaymentChannelsRequest = {Coercible0: () => {}};
const hasFieldGetPaymentChannelsResponse = dictHasField => dictHasField;
const hasFieldGetPaymentChannelsRequest = dictHasField => dictHasField;
const genericGetPaymentChannelsResponse = {to: x => x, from: x => x};
const showGetPaymentChannelsResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dPayments$dTypes.showChannelInfo.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["channels", $0(v.channels)]))([]);
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "GetPaymentChannelsResponse"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetPaymentChannelsResponse = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "channels"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dPayments$dTypes.unscrambleDecodeChannelInfo.unsafeDecode)
    })(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetPaymentChannelsRequest = {to: x => x, from: x => x};
const showGetPaymentChannelsRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["restaurantId", Data$dShow.showIntImpl(v.restaurantId)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "GetPaymentChannelsRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetPaymentChannelsRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "restaurantId"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeGetPaymentChannelsResponse = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "GetPaymentChannelsResponse"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "channels"})((() => {
        const $0 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dPayments$dTypes.encodeChannelInfo.encode);
        return {encodeWithOptions: v => $0};
      })());
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const encodeGetPaymentChannelsRequest = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "GetPaymentChannelsRequest"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "restaurantId"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const decodeGetPaymentChannelsResponse = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericGetPaymentChannelsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetPaymentChannelsResponse"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "channels"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dPayments$dTypes.decodeChannelInfo);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
const decodeGetPaymentChannelsRequest = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetPaymentChannelsRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  GetPaymentChannelsRequest,
  GetPaymentChannelsResponse,
  decodeGetPaymentChannelsRequest,
  decodeGetPaymentChannelsResponse,
  encodeGetPaymentChannelsRequest,
  encodeGetPaymentChannelsResponse,
  encodingOpts,
  eqGetPaymentChannelsReque,
  eqGetPaymentChannelsRespo,
  genericGetPaymentChannelsRequest,
  genericGetPaymentChannelsResponse,
  hasFieldGetPaymentChannelsRequest,
  hasFieldGetPaymentChannelsResponse,
  newtypeGetPaymentChannelsRequest,
  newtypeGetPaymentChannelsResponse,
  rpcMethodNameGetPaymentChannelsRequest,
  showGetPaymentChannelsRequest,
  showGetPaymentChannelsResponse,
  unscrambleDecodeGetPaymentChannelsRequest,
  unscrambleDecodeGetPaymentChannelsResponse
};
